import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { navigateToAccountIdPage } from "./hooks";
import { CustomCheckbox } from "../../components/input/checkbox";
import { AnimatedToggle } from "../../components/animatedHeight";

export const ManageRepaymentsOption = ({
    accountId,
    title,
    subRoute,
    children,
    changeTitleColourWhenActive,
  }) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const optionRoute = path + subRoute;
  const match = useRouteMatch({ path: optionRoute, exact: false });

  const changeTitleColor = changeTitleColourWhenActive && match;

  const navigateTo = (route) => () => {
    navigateToAccountIdPage(accountId, history, path + route);
  };

  return (
    <>
      <CustomCheckbox
        title={title}
        onChange={navigateTo(subRoute)}
        value={match || ""}
        changeTitleColor={changeTitleColor}
      />
      <AnimatedToggle show={!!match}>{children}</AnimatedToggle>
    </>
  );
};